import React from 'react'
import '../../styles/table-main/main.css';

const Main = () => {
  return (
    <div>
        <div className="tableMain"> 
            <div className="container mt-5 mb-5 admin-container">
                <div className="row">
                    <div className="col-md-12 pull-left flip sm-pull-none">
                        <div className="admin-table">
                            <h2 className="my-heading">Admission Brochure 2024</h2>
                            <div className="table-scrollable">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>S.no</th>
                                            <th>Title</th>
                                            <th>Download</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>1</td>
                                            <td>Information Brochure 2025-26</td>
                                            <td><a href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/06/University%20&%20Colleges%20Brochure-2025-26.pdf" target="_blank" rel="noreferrer" className="btn btn-primary btn-download">Download</a></td>
                                        </tr>
                                        <tr>
                                            <td>1</td>
                                            <td>Information Brochure 2024-25</td>
                                            <td><a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/University%20Campus%20Brochure%202024-25(updated%20on%2030-05-2024).pdf" target="_blank" rel="noreferrer" className="btn btn-primary btn-download">Download</a></td>
                                        </tr>
                                        <tr>
                                            <td>2</td>
                                            <td>Information Brochure 2023-24</td>
                                            <td><a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/04/University-Campus-Admission-Brochure_2023-24.pdf" target="_blank" rel="noreferrer" className="btn btn-primary btn-download">Download</a></td>
                                        </tr>
                                        <tr>
                                            <td>3</td>
                                            <td>Admission Notice & Rules 2023-24
                                                (University Campus and Affiliated Colleges)</td>
                                            <td><a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/04/Eligibility-Criteria-and-Admission-Rules_2023-24.pdf" target="_blank" rel="noreferrer" className="btn btn-primary btn-download">Download</a></td>
                                        </tr>

                                        </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
  )
}

export default Main;